import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EstructuraDeServicios.css";

// Contenido y funciones del servicio
const funciones = [
  "Función 1",
  "Función 2",
  "Función 3",
  "Función 4",
  "Función 5"
];

const SGA = () => {
  const [selectedImage, setSelectedImage] = useState(1);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const handleThumbnailClick = (num) => {
    setSelectedImage(num);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(num - 1);
    }
  };

  return (
    <div className="producto-detalle">
      <div className="fondo-sga">
        <img 
          src="/images/serviciosbackground.jpg" 
          alt="Imagen de fondo Gestión de Almacén"
        />
        <div className="fondo-sga-overlay"></div>
      </div>

      <header className="fade-in">
        <h1 className="titulo-sga">SGA: Gestión de Almacén</h1>
      </header>

      <section className="detalle-contenido fade-in">
        <img
          src={`/images/sga1.jpg`}
          alt="SGA 1"
          className="detalle-imagen"
        />
        <div className="descripcion">
          <p>
            Mejora la trazabilidad y reduce errores con este sistema de gestión de almacén avanzado. Agiliza los procesos logísticos de manera eficiente.
          </p>
        </div>
      </section>

      <section className="funciones fade-in">
        <h2>Funciones Destacadas</h2>
        <ul>
          {funciones.map((funcion, index) => (
            <li key={index}>✓ {funcion}</li>
          ))}
        </ul>
      </section>

      <section className="carrusel fade-in">
        <h2>Galería</h2>
        <Slider {...settings} ref={sliderRef}>
          {[1, 2, 3, 4, 5].map((num) => (
            <div key={num}>
              <img
                src={`/images/sga${num}.jpg`}
                alt={`SGA ${num}`}
                className="carrusel-imagen"
              />
            </div>
          ))}
        </Slider>
      </section>

      <section className="album-miniaturas fade-in">
        <h2>Vista Completa</h2>
        <div className="album">
          {[1, 2, 3, 4, 5].map((num) => (
            <img
              key={num}
              src={`/images/sga${num}.jpg`}
              alt={`SGA ${num}`}
              className="miniatura"
              onClick={() => handleThumbnailClick(num)}
            />
          ))}
        </div>
      </section>

      <section className="cta fade-in">
        <h2>Optimiza tu Almacén</h2>
        <p>Agiliza tus procesos logísticos con nuestro sistema avanzado de gestión de almacén.</p>
        <button className="btn-cta">Solicitar una Demo</button>
      </section>
    </div>
  );
};

export default SGA;
